<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="width"
    :modal="modal"
    :before-close="onClose"
    :show-close="showClose"
    @close="_close"
    @open="_open"
    :close-on-click-modal="closeOnClickModal"
    :top="top"
    append-to-body
  >
    <div class="dialog_box">
      <slot></slot>
      <div class="dialog_btn">
        <slot name="footers">
          <slot name="btn_l"></slot>
          <slot name="btn_r"></slot>
        </slot>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Modal",
  props: {
    title: {
      // 标题
      type: String,
      default: "提示",
    },
    width: {
      // 弹窗宽度
      type: String,
    },
    modal: {
      // 弹窗遮罩
      type: Boolean,
      default: true,
    },
    visible: {
      // 弹窗显示
      type: Boolean,
      default: false,
    },
    top: {
      // 弹窗顶部距离
      type: String,
      default: "30vh",
    },
    beforeClose: {
      //关闭弹窗前的回调
      type: Function,
    },
    close: {
      // 弹窗关闭回调
      type: Function,
    },
    open: {
      // 打开的回调
      type: Function,
    },
    closeOnClickModal: {
      // 点击遮罩关闭弹窗
      type: Boolean,
      default: false,
    },
    showClose: {
      // 关闭按钮
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClose() {
      this.$emit("update:visible", false);
    },
    _close() {
      this.$emit("update:visible", this.visible);
      this.$emit("close");
    },
    _open() {
      this.$emit("open");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  /*border: 5px solid #00c1ba;*/
  border-radius: 2px;
}
.dialog_btns {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-dialog__header {
  /*background-color: #00c1ba;*/
  border-bottom: 1px solid #e6e6e6;
  height: 50px;

  padding: 0;

  .el-dialog__title {
    color: #001528;
    font-size: 16px;
    line-height: 50px;
    padding-left: 20px;
    font-weight: bold;
  }
}

::v-deep .el-dialog__headerbtn {
  top: 20px;
  i {
    color: #2e2d3c;
  }
}

::v-deep .el-form-item__label {
  width: auto;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
  position: relative;
  top: -7px;
}

::v-deep .el-dialog__footer {
  text-align: right;
  padding: 10px 0;
  // border-top: 1Px solid #f2f2f2;
  .el-button {
    margin-right: 15px;
  }
}
</style>
